export const INTEGRATION_PARTNERS = {
  Slate: 'slate',
  SlateSourceFormat: 'slate-source-format',
  Scoir: 'scoir',
}

export const APPLICANT_TYPES = {
  FirstYear: 'firstYear',
  Transfer: 'transfer',
  Both: 'both',
}
